import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import {
  Form,
  Row,
  Col,
  Button,
  Input,
  message,
  Modal,
  Dropdown,
  Menu,
  Card,
  Popover,
  Select,
} from "antd";
import LocationAutocomplete from "../../Components/Autocomplete";
import { withAppContext } from "../../store/contextStore";
import AppConfigs from "../../Config/AppConfig";
import { Auth, Storage } from "aws-amplify";
import { list } from "../../api/Apis";
import UserLogo from "../../Images/user.png";
import { update } from "../../api/Apis";
import { formatPhoneNumber, formatPhoneNumber1 } from "../commonFunctions";
import ResizableAntdTable from "resizable-antd-table";
import { doRegistration } from "../../api/RegistrationsApis";
import { noWhitespaceRule, notValidPhoneNumberRule } from "../../utils/Utils";
import { CSVLink } from "react-csv";
import moment from "moment";
import DownloadCsv from "../../Components/DownloadCsv";
const Search = Input.Search;

class Settings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userDetails: JSON.parse(localStorage.getItem("userDetails")),
      orgDetails: JSON.parse(localStorage.getItem("orgDetails")),
      dataLoadingStatus: true,
      yardLocations: [],
      totalYardLocations: [],
      usersData: [],
      totalUsersData: [],
      visible: false,
      imageModal: false,
      subVisible: false,
      displayProducts: [],
      categories: [],
      subCategories: [],
      displaySub: [],
      masterData: { category: [], subCategory: [] },
      selectedCategory: "",
      selectedTag: "",
      questionTitle: "",
      title: "",
      mapPath: "",
      categoriesDataLoading: false,
      subCategoriesDataLoading: false,
      tagsDataLoading: false,
      userModalVisible: false,
      userData: {},
      formSubmitStatus: false,
      buttonText: "",
      csvData: [],
    };
  }

  componentDidMount() {
    if (this.state.orgDetails.approvalStatus === "D") {
      this.props.history.push("/carrier_app/review");
    } else if (
      !this.state.orgDetails["carrierFiles"] ||
      !("documents" in this.state.orgDetails["carrierFiles"])
    ) {
      this.props.history.push("/carrier_app/documentation");
    } else if (!this.state.orgDetails["isActive"]) {
      this.props.history.push("/carrier_app/review");
    }
    this.getUsers();
  }
  getUsers = () => {
    let query = {
      userProfile: "SCA",
      // "orgId": this.state.orgDetails["id"]
    };
    this.setState({
      dataLoadingStatus: true,
    });
    list(AppConfigs["entityNames"]["users"], query).then(async (result) => {
      if (result.success) {
        let usersData = [];
        let userCount = 0;
        await result["data"].map(async (user) => {
          if (this.state.userDetails["id"] !== user.id) {
            let userImg = user["profilePic"]
              ? await Storage.get(user["profilePic"])
              : UserLogo;
            user["avatar"] = (
              <img
                src={userImg}
                style={{
                  width: "75px",
                  height: "75px",
                  borderRadius: "10px",
                }}
                alt={user["firstName"]}
              />
            );
            usersData.push(user);
            userCount += 1;
            if (userCount === usersData.length) {
              this.setState({
                dataLoadingStatus: false,
                totalUsersData: usersData,
                usersData: usersData,
                csvData: this.p,
              });
            }
            return user;
          }
        });
      } else {
        this.setState({
          dataLoadingStatus: false,
        });
        message.error(result.errors.message.message);
      }
    });
    this.setState({
      dataLoadingStatus: false,
    });
  };

  prepareCsvData = (data) => {
    let csvData = [];
    data.map((user) => {
      csvData.push({
        "First Name": user["firstName"],
        "Last Name": user["lastName"],
        "Email": user["email"],
        "Phone": user["phone"],
      });
    });
    return csvData;
  }

  generateCsvData = () => {
    return this.prepareCsvData(this.state.usersData);
  }

  handleConfirmBlur = (e) => {
    const { value } = e.target;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  };

  compareToFirstPassword = (rule, value, callback) => {
    const { form } = this.props;
    if (value && value !== form.getFieldValue("password")) {
      callback("Password and confirm password must be same");
    } else {
      callback();
    }
  };

  handleEdit = (e) => {
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.setState({
          formSubmitStatus: true,
        });
        if (this.state.buttonText === "Update") {
          let data = {
            entityData: {
              firstName: values["firstName"],
              lastName: values["lastName"],
              email: values["email"],
              phone: values["phone"],
              userProfile: "SCA",
              orgId: this.state.orgDetails["id"],
              recordStatus: true,
              isActive: false,
            },
          };
          update(
            AppConfigs["entityNames"]["users"],
            this.state.userData.id,
            data
          ).then((result) => {
            if (result.success) {
              message.success(`User details updated successfully.`);
            } else {
              message.error(result.errors);
            }
            this.getUsers();
            this.props.form.resetFields();
            this.setState({
              formSubmitStatus: false,
              userModalVisible: false,
              buttonText: "",
              userData: {},
            });
          });
        } else if (this.state.buttonText === "Add") {
          let data = {
            entityData: {
              firstName: values["firstName"],
              lastName: values["lastName"],
              companyName: values["companyName"] ? values["companyName"] : null,
              // address: values["address"] ? values["address"] : null,
              city: null,
              stateText: null,
              zip: null,
              email: values["email"],
              phone: values["phone"].toString(),
              userProfile: "SCA",
              registrationType: "carrier",
              orgId: this.state.orgDetails["id"],
              recordStatus: true,
              isActive: false,
              mc: values["mc"] ? values["mc"] : null,
              dot: values["dot"] ? values["dot"] : null,
            },
          };
          this.addUser(values["email"], values["password"], data);
        }
      }
    });
  };

  getAddress = (address, latLng, id) => {
    this.props.form.setFieldsValue({
      [id]: address,
    });
    let latLangs = this.state.latLangs;
    this.setState({
      latLangs,
    });
  };

  addUser = async (email, password, regData) => {
    await Auth.signUp({
      username: email,
      password: password,
    })
      .then((data) => {
        regData["entityData"]["userId"] = data.userSub;
        doRegistration(regData).then((result) => {
          if (result.success) {
            message.success(`Carrier created successfully.`);
            this.getUsers();
            this.props.form.resetFields();
            this.setState({
              formSubmitStatus: false,
              userModalVisible: false,
              buttonText: "",
              userData: {},
            });
            // add(AppConfigs["entityNames"]["users"], regData).then((result) => {
            //   if (result.success) {

            //   } else {
            //     this.setState({ formSubmitStatus: false });
            //     message.error(result.errors);
            //   }
            // });
          } else {
            this.setState({ formSubmitStatus: false });
            message.error(result.errors);
          }
        });
      })
      .catch((err) => {
        if (err.code === "InvalidPasswordException") {
          message.error(
            "Invalid Password: \n- Minimum password length:6\n- Require at least one uppercase letter\n- Require at least one lowercase letter\n- Require at least one number\n- Require at least one nonalphanumeric character"
          );
        } else {
          message.error(err.message);
        }
        this.setState({ formSubmitStatus: false });
      });
  };

  // deleteUser = (id) => {
  //   this.setState({ dataLoadingStatus: true });
  //   deleteRecord(AppConfigs["entityNames"]["users"], id).then((result) => {
  //     if (result.success) {
  //       message.success("User deleted successfully");
  //       this.getUsers();
  //     } else {
  //       console.log(result.errors);
  //     }
  //   });
  // };

  // async resendConfirmationCode(username) {
  //   try {
  //     this.setState({ dataLoadingStatus: true });
  //     await Auth.resendSignUp(username);
  //     this.setState({ dataLoadingStatus: false });
  //     message.success("code resent successfully");
  //   } catch (err) {
  //     console.log("error resending code: ", err);
  //   }
  // }

  searchData = (event, searchBy) => {
    let searcingValue = event.target.value;
    let usersData = this.state.totalUsersData;
    let yardLocations = this.state.totalYardLocations;
    if (searcingValue.length > 0) {
      searcingValue = searcingValue.toLowerCase();
      if (searchBy === "users") {
        // usersData = this.state.totalUsersData.filter((user) => user.firstName.toLowerCase().indexOf(searcingValue) > -1 || user.lastName.toLowerCase().indexOf(searcingValue) > -1 || user.email.indexOf(searcingValue) > -1)
        usersData = this.state.totalUsersData.filter(
          (user) =>
            user.firstName.toLowerCase().indexOf(searcingValue) > -1 ||
            user.lastName.toLowerCase().indexOf(searcingValue) > -1 ||
            user.email.indexOf(searcingValue) > -1 ||
            user.phone.toLowerCase().indexOf(searcingValue) > -1
        );
      } else {
        // yardLocations = this.state.totalYardLocations.filter((location) => location.locationName.toLowerCase().indexOf(searcingValue) > -1 || location.address.toLowerCase().indexOf(searcingValue) > -1 || location.firstName.toLowerCase().indexOf(searcingValue) > -1 || location.lastName.toLowerCase().indexOf(searcingValue) > -1 || (location.loadTypes && location.loadTypes.join(", ").toLowerCase().indexOf(searcingValue) > -1) || (location.materialsLoaded && location.materialsLoaded.join(", ").toLowerCase().indexOf(searcingValue) > -1))
        yardLocations = this.state.totalYardLocations.filter(
          (location) =>
            location.locationName.toLowerCase().indexOf(searcingValue) > -1 ||
            location.address.toLowerCase().indexOf(searcingValue) > -1 ||
            location.firstName.toLowerCase().indexOf(searcingValue) > -1 ||
            location.lastName.toLowerCase().indexOf(searcingValue) > -1 ||
            (location.loadTypes &&
              location.loadTypes
                .join(", ")
                .toLowerCase()
                .indexOf(searcingValue) > -1) ||
            (location.materialsLoaded &&
              location.materialsLoaded
                .join(", ")
                .toLowerCase()
                .indexOf(searcingValue) > -1) ||
            location.phone.toLowerCase().indexOf(searcingValue) > -1 ||
            location.loadingTimes.toLowerCase().indexOf(searcingValue) > -1
        );
      }
    }
    this.setState({
      usersData: usersData,
      yardLocations: yardLocations,
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const usersColumns = [
      {
        title: <div style={{ color: "gray" }}>Avatar</div>,
        dataIndex: "avatar",
        key: "avatar",
      },
      {
        title: <div style={{ color: "gray" }}>First Name</div>,
        dataIndex: "firstName",
        key: "firstName",
        render: (firstName) => (
          <span>
            <div style={{ color: "black" }}>{firstName}</div>
          </span>
        ),
      },
      {
        title: <div style={{ color: "gray" }}>Last Name</div>,
        dataIndex: "lastName",
        key: "lastName",
        render: (lastName) => (
          <span>
            <div style={{ color: "black" }}>{lastName}</div>
          </span>
        ),
      },
      {
        title: <div style={{ color: "gray" }}>Email</div>,
        dataIndex: "email",
        key: "email",
        render: (email) => (
          <span>
            <div style={{ color: "black" }}>{email}</div>
          </span>
        ),
      },
      {
        title: <div style={{ color: "gray" }}>Phone</div>,
        dataIndex: "phone",
        key: "phone",
        render: (phone) => (
          <span>
            <div style={{ color: "black" }}>
              {phone.length === 10
                ? formatPhoneNumber(phone)
                : formatPhoneNumber1(phone)}
            </div>
          </span>
        ),
      },
      {
        title: <div style={{ color: "grey" }}>Action</div>,
        dataIndex: "id",
        key: "id",
        render: (id, record) => (
          <Dropdown overlay={menu(id, record)} placement="bottomRight">
            <Button>...</Button>
          </Dropdown>
        ),
      },
    ];
    const menu = (id, record) => (
      <Menu>
        {/* {this.state.userDetails["id"] !== id && (
          <Menu.Item className="blue">
            <span
              style={{ color: "rgba(0, 0, 0, 0.65)", cursor: "pointer" }}
              onClick={() => {
                if (
                  window.confirm("Are you sure you want to delete this user?")
                )
                  this.deleteUser(id);
              }}
            >
              Delete
            </span>
          </Menu.Item>
        )} */}
        <Menu.Item className="blue">
          <span
            style={{ color: "rgba(0, 0, 0, 0.65)", cursor: "pointer" }}
            onClick={() => {
              this.setState({
                userModalVisible: true,
                userData: record,
                buttonText: "Update",
              });
            }}
          >
            Edit
          </span>
        </Menu.Item>
        {/* <Menu.Item className="blue">
          <span style={{ color: "rgba(0, 0, 0, 0.65)", cursor: "pointer" }}>
            <ChangePassword color={"rgba(0, 0, 0, 0.65)"} />
          </span>
        </Menu.Item> */}
        {/* {!record.isActive && (
          <Menu.Item className="blue">
            <span
              style={{ color: "rgba(0, 0, 0, 0.65)", cursor: "pointer" }}
              onClick={() => {
                this.resendConfirmationCode(id);
              }}
            >
              Resend Activation Code
            </span>
          </Menu.Item>
        )} */}
      </Menu>
    );

    let passwordCriteria = (
      <div>
        <Row>
          <Col lg={24} md={24} sm={24} xs={24}>
            -Minimum password length: 6 <br />
            -Required at least one uppercase letter
            <br />
            -Required at least one lowercase letter
            <br />
            -Required at least one number
            <br />
            -Required at least one special character
            <br />
          </Col>
        </Row>
      </div>
    );

    // let categories = { "BULK GRAVEL": ["NEW ENGLAND RIVER ROCK", "BAYSIDE SKIMMERS", "WINCHESTER RIVER ROCK", "CAPE COD RIVER ROCK", "BERKSHIRE BLEND", "BOSTON PURPLE", "CRUSHED COLOR BLEND", "LAKESIDE RIVER ROCK", "ICE BLUE", "GLACIER RIVER ROCK", "CATSKILL RIVER ROCK", "WHITE MARBLE STONE", "SLATE", "SAND", "HARVEST BLEND", "WHITE RIVER ROCK", "LIBERTY PINK"], "PALLETIZED STONE": ["CRUSHED STONE", "PREMIUM STONE LINE", "PALLETIZED RIVER ROCK", "VENEER / FLAGSTONE"] }
    return (
      <div className="content-outer">
        <div className="content">
          <Row>
            <Col xs={24} sm={24} md={24} lg={24}>
              <Row style={{ margin: "20px" }}>
                <Col xs={24} sm={24} md={4} lg={4}>
                  <Search
                    className="products-search"
                    size="large"
                    placeholder="Search"
                    onChange={(event) => this.searchData(event, "users")}
                  />
                </Col>
                <Col xs={24} sm={24} md={20} lg={20}>
                  <Button
                    type="primary"
                    htmlType="submit"
                    loading={this.state.loading}
                    onClick={() =>
                      this.setState({
                        userModalVisible: true,
                        userData: {},
                        buttonText: "Add",
                      })
                    }
                    className="upload-button"
                    icon="plus"
                  >
                    Add Carrier
                  </Button>
                </Col>
                <Col
                  lg={24}
                  md={24}
                  sm={24}
                  xs={24}
                  style={{ marginTop: "2%" }}
                >
                  <ResizableAntdTable
                    bordered={true}
                    columns={usersColumns}
                    dataSource={this.state.usersData}
                    loading={this.state.dataLoadingStatus}
                    rowKey={(record) => record.id}
                    style={{ overflowX: "auto" }}
                  />
                </Col>
                <Modal
                  // title={this.state.categoryTitle}
                  visible={this.state.userModalVisible}
                  footer={[
                    <Button
                      key="cancel"
                      className="cancel"
                      onClick={() => {
                        this.props.form.resetFields();
                        this.setState({
                          userModalVisible: false,
                          formSubmitStatus: false,
                        });
                      }}
                    >
                      Cancel
                    </Button>,
                    <Button
                      key="assign"
                      className="assigning"
                      loading={this.state.formSubmitStatus}
                      onClick={this.handleEdit}
                    >
                      {this.state.buttonText}
                    </Button>,
                  ]}
                >
                  <div className="site-card-border-less-wrapper">
                    <Form>
                      <Card
                        title={
                          <h4 className="Companyheadinglabel">
                            {this.state.buttonText === "Add"
                              ? "Add Carrier"
                              : "Edit Carrier"}
                          </h4>
                        }
                        style={{ borderRadius: "10px" }}
                      >
                        <Row gutter={10}>
                          <Col lg={24} md={24} sm={24} sx={24}>
                            <Form.Item
                              className="Formitem"
                              label={
                                <span
                                  style={{
                                    color: "#7B8190",
                                    fontSize: "14px",
                                  }}
                                >
                                  First Name
                                </span>
                              }
                            >
                              {getFieldDecorator("firstName", {
                                rules: [
                                  {
                                    required: true,
                                    message: "Please input your First Name!",
                                  },
                                ],
                                initialValue: this.state.userData.firstName,
                              })(<Input />)}
                            </Form.Item>
                          </Col>
                          <Col lg={24} md={24} sm={24} sx={24}>
                            <Form.Item
                              className="Formitem"
                              label={
                                <span
                                  style={{
                                    color: "#7B8190",
                                    fontSize: "14px",
                                  }}
                                >
                                  Last Name
                                </span>
                              }
                            >
                              {getFieldDecorator("lastName", {
                                rules: [
                                  {
                                    required: true,
                                    message: "Please input your Last Name!",
                                  },
                                ],
                                initialValue: this.state.userData.lastName,
                              })(<Input />)}
                            </Form.Item>
                          </Col>
                          {/* <Col lg={24} md={24} sm={24} sx={24}>
                            <Form.Item
                              className="Formitem"
                              label={
                                <span
                                  style={{
                                    color: "#7B8190",
                                    fontSize: "14px",
                                  }}
                                >
                                  Address
                                </span>
                              }
                            >
                              {getFieldDecorator("address", {
                                rules: [
                                  {
                                    required: true,
                                    message: "Please input your Address!",
                                  },
                                ],
                                initialValue: this.state.userData.address
                              })(
                                <LocationAutocomplete
                                  getAddress={(address, latLng) =>
                                    this.getAddress(address, latLng, "address")
                                  }
                                  editMode={false}
                                />
                              )}
                            </Form.Item>
                          </Col> */}
                          <Col lg={24} md={24} sm={24} sx={24}>
                            <Form.Item
                              className="Formitem"
                              label={
                                <span
                                  style={{
                                    color: "#7B8190",
                                    fontSize: "14px",
                                  }}
                                >
                                  Email
                                </span>
                              }
                            >
                              {getFieldDecorator("email", {
                                rules: [
                                  {
                                    required: true,
                                    type: "email",
                                    message: "Please input your Email!",
                                  },
                                ],
                                initialValue: this.state.userData.email,
                              })(<Input />)}
                            </Form.Item>
                          </Col>
                          <Col lg={24} md={24} sm={24} sx={24}>
                            <Form.Item
                              className="Formitem"
                              label={
                                <span
                                  style={{
                                    color: "#7B8190",
                                    fontSize: "14px",
                                  }}
                                >
                                  Phone
                                </span>
                              }
                            >
                              {getFieldDecorator("phone", {
                                rules: [
                                  {
                                    required: true,
                                    message: "Please input your Phone Number!",
                                  },
                                  noWhitespaceRule,
                                  notValidPhoneNumberRule,
                                ],
                                initialValue: this.state.userData.phone,
                              })(<Input />)}
                            </Form.Item>
                          </Col>
                          {/* <Col lg={24} md={24} sm={24} sx={24}>
                            <Form.Item
                              className="Formitem"
                              label={
                                <span
                                  style={{ color: "#7B8190", fontSize: "14px" }}
                                >
                                  User Profile
                                </span>
                              }
                            >
                              {getFieldDecorator("userProfile", {
                                rules: [
                                  {
                                    required: true,
                                    message: "Please input your User Profile!",
                                  },
                                ],
                                initialValue:"Sub User"
                                  // this.state.userData.userProfile === "CA"
                                  //   ? "Carrier Admin"
                                  //   : this.state.userData.userProfile === "D"
                                  //   ? "Sub User"
                                  //   : ""                                    
                              })(
                                <Select>
                                  {/* <Option value="CA">Carrier Admin</Option> */}
                          {/* <Option value="SCA">Sub User</Option>
                                </Select> */}
                          {/* )} */}
                          {/* </Form.Item>
                          </Col> */}

                          {this.state.buttonText === "Add" && (
                            <Col lg={12} md={12} sm={12} sx={12}>
                              <Form.Item
                                className="Formitem"
                                label={<span className="label">Password</span>}
                              >
                                {getFieldDecorator("password", {
                                  rules: [
                                    {
                                      required: true,
                                      message: "Please input your password!",
                                    },
                                    {
                                      min: 6,
                                      message:
                                        "Password must have a minimum length of 6",
                                    },
                                    {
                                      pattern: new RegExp(
                                        "^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[@$!%*?&])[A-Za-z\\d@$!%*?&]{8,}$"
                                      ),
                                      message:
                                        "Password must contain at least one lowercase letter, uppercase letter, number, and special character",
                                    },
                                  ],
                                })(
                                  <Input.Password
                                    placeholder="*********"
                                    autoComplete="new-password"
                                  />
                                )}
                              </Form.Item>
                              <Popover
                                placement="top"
                                title={
                                  <h2 style={{ textAlign: "center" }}>
                                    Password Criteria
                                  </h2>
                                }
                                content={passwordCriteria}
                                trigger="hover"
                              >
                                <span style={{ color: "#20a8d8" }}>
                                  Criteria
                                </span>
                              </Popover>
                            </Col>
                          )}
                          {this.state.buttonText === "Add" && (
                            <Col lg={12} md={12} sm={12} sx={12}>
                              <Form.Item
                                className="Formitem"
                                label={
                                  <span className="label">
                                    Confirm Password
                                  </span>
                                }
                              >
                                {getFieldDecorator("confirm", {
                                  rules: [
                                    {
                                      required: true,
                                      message: "Please confirm your password!",
                                    },
                                    { validator: this.compareToFirstPassword },
                                  ],
                                })(
                                  <Input.Password
                                    placeholder="*********"
                                    onBlur={this.handleConfirmBlur}
                                  />
                                )}
                              </Form.Item>
                            </Col>
                          )}
                        </Row>
                      </Card>
                    </Form>
                  </div>
                </Modal>
                <Button>
                  {/* <DownloadCsv data={this.generateCsvData} filename='Settings' columns={this.prepareCsvData()} /> */}
                  <CSVLink
                    data={this.generateCsvData()}
                    filename={`Carriers_${moment().format('DD_MM_YY')}.csv`}
                    className="csv-download-link"
                    >
                    Download CSV
                  </CSVLink>
                </Button>
              </Row>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}
export default Form.create({ name: "settings" })(
  withAppContext(withRouter(Settings))
);
// export default withAppContext(withRouter(Settings));
